"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableChildPerspectiveNodes = exports.PerspectiveCustomJoinTreeNode = exports.PerspectiveTableReferenceNode = exports.PerspectiveTableNode = exports.PerspectivePatternColumnNode = exports.PerspectiveTableColumnNode = exports.PerspectiveTreeNode = void 0;
const dbgate_tools_1 = require("dbgate-tools");
const PerspectiveConfig_1 = require("./PerspectiveConfig");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const compact_1 = __importDefault(require("lodash/compact"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const cloneDeepWith_1 = __importDefault(require("lodash/cloneDeepWith"));
const findIndex_1 = __importDefault(require("lodash/findIndex"));
const json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
const dbgate_filterparser_1 = require("dbgate-filterparser");
// import { getPerspectiveDefaultColumns } from './getPerspectiveDefaultColumns';
const v1_1 = __importDefault(require("uuid/v1"));
const perspectiveTools_1 = require("./perspectiveTools");
// export function groupPerspectiveLoadProps(
//   ...list: PerspectiveDataLoadPropsWithNode[]
// ): PerspectiveDataLoadPropsWithNode[] {
//   const res: PerspectiveDataLoadPropsWithNode[] = [];
//   for (const item of list) {
//     const existing = res.find(
//       x =>
//         x.node == item.node &&
//         x.props.schemaName == item.props.schemaName &&
//         x.props.pureName == item.props.pureName &&
//         _isEqual(x.props.bindingColumns, item.props.bindingColumns)
//     );
//     if (existing) {
//       existing.props.bindingValues.push(...item.props.bindingValues);
//     } else {
//       res.push(_cloneDeep(item));
//     }
//   }
//   return res;
// }
class PerspectiveTreeNode {
    constructor(dbs, config, setConfig, parentNode, dataProvider, defaultDatabaseConfig, designerId) {
        this.dbs = dbs;
        this.config = config;
        this.setConfig = setConfig;
        this.parentNode = parentNode;
        this.dataProvider = dataProvider;
        this.defaultDatabaseConfig = defaultDatabaseConfig;
        this.designerId = designerId;
        this.childNodesCache = null;
        this.nodeConfig = config.nodes.find(x => x.designerId == designerId);
        this.parentNodeConfig = parentNode === null || parentNode === void 0 ? void 0 : parentNode.nodeConfig;
    }
    get childNodes() {
        if (!this.childNodesCache) {
            this.childNodesCache = this.generateChildNodes();
        }
        return this.childNodesCache;
    }
    get fieldName() {
        return this.codeName;
    }
    get headerTableAttributes() {
        return null;
    }
    get dataField() {
        return this.codeName;
    }
    get tableCode() {
        return null;
    }
    get namedObject() {
        return null;
    }
    get tableNodeOrParent() {
        if (this instanceof PerspectiveTableNode) {
            return this;
        }
        if (this.parentNode == null) {
            return null;
        }
        return this.parentNode.tableNodeOrParent;
    }
    get engineType() {
        return null;
    }
    get databaseConfig() {
        var _a, _b, _c, _d;
        const res = Object.assign({}, this.defaultDatabaseConfig);
        if ((_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.conid)
            res.conid = (_b = this.nodeConfig) === null || _b === void 0 ? void 0 : _b.conid;
        if ((_c = this.nodeConfig) === null || _c === void 0 ? void 0 : _c.database)
            res.database = (_d = this.nodeConfig) === null || _d === void 0 ? void 0 : _d.database;
        return res;
    }
    get isRoot() {
        return this.parentNode == null;
    }
    get rootNode() {
        var _a;
        if (this.isRoot)
            return this;
        return (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.rootNode;
    }
    get isSortable() {
        return false;
    }
    get generatesHiearchicGridColumn() {
        return this.isExpandable && this.isCheckedNode;
    }
    get generatesDataGridColumn() {
        return this.isCheckedColumn;
    }
    get validParentDesignerId() {
        var _a;
        if (this.designerId)
            return this.designerId;
        return (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.validParentDesignerId;
    }
    get preloadedLevelData() {
        return false;
    }
    get findByDesignerIdWithoutDesignerId() {
        return false;
    }
    matchChildRow(parentRow, childRow) {
        return true;
    }
    hasTableCode(code) {
        var _a;
        return code == this.tableCode || ((_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.hasTableCode(code));
    }
    // get uniqueName() {
    //   if (this.parentNode) return `${this.parentNode.uniqueName}::${this.codeName}`;
    //   return this.codeName;
    // }
    get level() {
        if (this.parentNode)
            return this.parentNode.level + 1;
        return 0;
    }
    get isExpanded() {
        var _a, _b;
        return (_b = (_a = this.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.expandedColumns) === null || _b === void 0 ? void 0 : _b.includes(this.codeName);
    }
    get isCheckedColumn() {
        var _a, _b;
        if ((_b = (_a = this.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.checkedColumns) === null || _b === void 0 ? void 0 : _b.includes(this.codeName))
            return true;
        return false;
    }
    get isChecked() {
        return this.isCheckedColumn;
    }
    get isCheckedNode() {
        var _a, _b;
        return !!this.designerId && !!((_b = (_a = this.config.nodes) === null || _a === void 0 ? void 0 : _a.find(x => x.designerId == this.designerId)) === null || _b === void 0 ? void 0 : _b.isNodeChecked);
    }
    get isSecondaryChecked() {
        return false;
    }
    get secondaryCheckable() {
        return false;
    }
    get columnTitle() {
        return this.title;
    }
    get filterBehaviour() {
        return dbgate_tools_1.stringFilterBehaviour;
    }
    get columnName() {
        return null;
    }
    get customJoinConfig() {
        return null;
    }
    get db() {
        var _a, _b;
        return (_b = (_a = this.dbs) === null || _a === void 0 ? void 0 : _a[this.databaseConfig.conid]) === null || _b === void 0 ? void 0 : _b[this.databaseConfig.database];
    }
    get isCircular() {
        return false;
    }
    get pathIdentifier() {
        if (this.parentNode)
            return `${this.parentNode.pathIdentifier}_${this.codeName}`;
        return this.codeName;
    }
    hasDesignerIdInIncestors(designerId) {
        var _a;
        if (designerId == this.designerId)
            return true;
        return ((_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.hasDesignerIdInIncestors(designerId)) || false;
    }
    getChildMatchColumns() {
        return [];
    }
    getParentMatchColumns() {
        return [];
    }
    parseFilterCondition(source = null) {
        return null;
    }
    get hasUncheckedNodeInPath() {
        if (!this.parentNode)
            return false;
        if (this.designerId && !this.isCheckedNode)
            return true;
        return this.parentNode.hasUncheckedNodeInPath;
    }
    get childDataColumn() {
        if (this.isCheckedColumn) {
            return this.codeName;
        }
        return null;
    }
    toggleExpanded(value) {
        this.includeInNodeSet('expandedColumns', value == null ? !this.isExpanded : value);
    }
    toggleChecked(value) {
        this.includeInNodeSet('checkedColumns', value == null ? !this.isChecked : value);
    }
    toggleCheckedNode(value) {
        this.setConfig(cfg => {
            var _a;
            const oldCheckedValue = (_a = cfg.nodes.find(x => x.designerId == this.designerId)) === null || _a === void 0 ? void 0 : _a.isNodeChecked;
            const [cfgChanged, nodeCfg] = this.ensureNodeConfig(cfg);
            const res = Object.assign(Object.assign({}, cfgChanged), { nodes: cfgChanged.nodes.map(node => node.designerId == (this.designerId || nodeCfg.designerId)
                    ? Object.assign(Object.assign({}, node), { isNodeChecked: value == null ? !oldCheckedValue : value }) : node) });
            return res;
        });
    }
    toggleSecondaryChecked(value) { }
    createReferenceConfigColumns() {
        return null;
    }
    ensureNodeConfig(cfg) {
        var _a, _b;
        let node = cfg.nodes.find(x => x.designerId == this.designerId);
        if (!node) {
            const nodeConfig = Object.assign(Object.assign({}, (0, PerspectiveConfig_1.createPerspectiveNodeConfig)(this.namedObject)), { isAutoGenerated: true, conid: (_a = this.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.conid, database: (_b = this.parentNodeConfig) === null || _b === void 0 ? void 0 : _b.database });
            const refConfig = {
                designerId: (0, v1_1.default)(),
                sourceId: this.parentNode.designerId,
                targetId: nodeConfig.designerId,
                isAutoGenerated: true,
                columns: this.createReferenceConfigColumns(),
            };
            return [
                Object.assign(Object.assign({}, cfg), { nodes: [...cfg.nodes, nodeConfig], references: [...cfg.references, refConfig] }),
                nodeConfig,
            ];
        }
        return [cfg, node];
    }
    includeInNodeSet(field, isIncluded) {
        this.setConfig(cfg => {
            var _a, _b;
            const changedFields = n => (Object.assign(Object.assign({}, n), { [field]: isIncluded ? [...(n[field] || []), this.codeName] : (n[field] || []).filter(x => x != this.codeName) }));
            const [cfgChanged, nodeCfg] = (_b = (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.tableNodeOrParent) === null || _b === void 0 ? void 0 : _b.ensureNodeConfig(cfg);
            const res = Object.assign(Object.assign({}, cfgChanged), { nodes: cfgChanged.nodes.map(n => { var _a, _b; return n.designerId == (((_b = (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.tableNodeOrParent) === null || _b === void 0 ? void 0 : _b.designerId) || (nodeCfg === null || nodeCfg === void 0 ? void 0 : nodeCfg.designerId)) ? changedFields(n) : n; }) });
            return res;
        });
    }
    getFilter() {
        var _a, _b;
        return (_b = (_a = this.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.filters) === null || _b === void 0 ? void 0 : _b[this.codeName];
    }
    getDataLoadColumns() {
        return (0, compact_1.default)((0, uniq_1.default)([
            ...this.childNodes.map(x => x.childDataColumn),
            ...(0, flatten_1.default)(this.childNodes.filter(x => x.isExpandable && x.isChecked).map(x => x.getChildMatchColumns())),
            ...this.getParentMatchColumns(),
            ...this.childNodes
                .filter(x => x instanceof PerspectivePatternColumnNode)
                .filter(x => { var _a, _b; return (_b = (_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.checkedColumns) === null || _b === void 0 ? void 0 : _b.find(y => y.startsWith(x.codeName + '::')); })
                .map(x => x.columnName),
        ]));
    }
    getMutliColumnCondition(source) {
        var _a;
        if (!((_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.multiColumnFilter))
            return null;
        const base = this.getBaseTableFromThis();
        if (!base)
            return null;
        const isDocDb = (0, dbgate_tools_1.isCollectionInfo)(base);
        if (isDocDb) {
            return this.getMutliColumnNoSqlCondition();
        }
        else {
            return this.getMutliColumnSqlCondition(source);
        }
    }
    getMutliColumnSqlCondition(source) {
        var _a, _b;
        if (!((_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.multiColumnFilter))
            return null;
        const base = this.getBaseTableFromThis();
        if (!base)
            return null;
        try {
            const condition = (0, dbgate_filterparser_1.parseFilter)((_b = this.nodeConfig) === null || _b === void 0 ? void 0 : _b.multiColumnFilter, dbgate_tools_1.stringFilterBehaviour);
            if (condition) {
                const orCondition = {
                    conditionType: 'or',
                    conditions: [],
                };
                for (const column of base.columns || []) {
                    orCondition.conditions.push((0, cloneDeepWith_1.default)(condition, (expr) => {
                        if (expr.exprType == 'placeholder') {
                            return {
                                exprType: 'column',
                                alias: source,
                                columnName: column.columnName,
                            };
                        }
                    }));
                }
                if (orCondition.conditions.length > 0) {
                    return orCondition;
                }
            }
        }
        catch (err) {
            console.warn(err.message);
        }
        return null;
    }
    getMutliColumnNoSqlCondition() {
        var _a, _b, _c, _d;
        if (!((_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.multiColumnFilter))
            return null;
        const pattern = (_c = (_b = this.dataProvider) === null || _b === void 0 ? void 0 : _b.dataPatterns) === null || _c === void 0 ? void 0 : _c[this.designerId];
        if (!pattern)
            return null;
        const condition = (0, dbgate_filterparser_1.parseFilter)((_d = this.nodeConfig) === null || _d === void 0 ? void 0 : _d.multiColumnFilter, dbgate_tools_1.mongoFilterBehaviour);
        if (!condition)
            return null;
        const orCondition = {
            conditionType: 'or',
            conditions: [],
        };
        for (const column of pattern.columns || []) {
            orCondition.conditions.push((0, cloneDeepWith_1.default)(condition, (expr) => {
                if (expr.exprType == 'placeholder') {
                    return {
                        exprType: 'column',
                        columnName: column.name,
                    };
                }
            }));
        }
        if (orCondition.conditions.length > 0) {
            return orCondition;
        }
    }
    getChildrenSqlCondition(source = null) {
        const conditions = (0, compact_1.default)([
            ...this.childNodes.map(x => x.parseFilterCondition(source)),
            ...this.buildParentFilterConditions(),
            this.getMutliColumnCondition(source),
        ]);
        if (conditions.length == 0) {
            return null;
        }
        if (conditions.length == 1) {
            return conditions[0];
        }
        return {
            conditionType: 'and',
            conditions,
        };
    }
    getOrderBy(table) {
        var _a;
        const res = (0, compact_1.default)(this.childNodes.map(node => {
            var _a, _b;
            const sort = (_b = (_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.sort) === null || _b === void 0 ? void 0 : _b.find(x => x.columnName == node.columnName);
            if (sort) {
                return {
                    columnName: node.columnName,
                    order: sort.order,
                };
            }
        }));
        if (res.length > 0)
            return res;
        const pkColumns = (_a = table === null || table === void 0 ? void 0 : table.primaryKey) === null || _a === void 0 ? void 0 : _a.columns.map(x => ({
            columnName: x.columnName,
            order: 'ASC',
        }));
        if (pkColumns)
            return pkColumns;
        const uqColumns = table === null || table === void 0 ? void 0 : table.uniqueKey;
        if ((uqColumns === null || uqColumns === void 0 ? void 0 : uqColumns.length) >= 1)
            return uqColumns.map(x => ({ columnName: x.columnName, order: 'ASC' }));
        const columns = table === null || table === void 0 ? void 0 : table.columns;
        if (columns)
            return [{ columnName: columns[0].columnName, order: 'ASC' }];
        return [{ columnName: '_id', order: 'ASC' }];
    }
    getBaseTables() {
        const res = [];
        const table = this.getBaseTableFromThis();
        if (table)
            res.push({ table, node: this });
        for (const child of this.childNodes) {
            if (!child.isChecked)
                continue;
            res.push(...child.getBaseTables());
        }
        return res;
    }
    getBaseTableFromThis() {
        return null;
    }
    get filterInfo() {
        return null;
    }
    findChildNodeByUniquePath(uniquePath) {
        if (uniquePath.length == 0) {
            return this;
        }
        const child = this.childNodes.find(x => x.codeName == uniquePath[0]);
        return child === null || child === void 0 ? void 0 : child.findChildNodeByUniquePath(uniquePath.slice(1));
    }
    // findNodeByUniqueName(uniqueName: string): PerspectiveTreeNode {
    //   if (!uniqueName) return null;
    //   const uniquePath = uniqueName.split('::');
    //   if (uniquePath[0] != this.codeName) return null;
    //   return this.findChildNodeByUniquePath(uniquePath.slice(1));
    // }
    findNodeByDesignerId(designerId) {
        if (!this.designerId && !this.findByDesignerIdWithoutDesignerId) {
            return null;
        }
        if (!designerId) {
            return null;
        }
        if (designerId == this.designerId) {
            return this;
        }
        for (const child of this.childNodes) {
            const res = child.findNodeByDesignerId(designerId);
            if (res) {
                return res;
            }
        }
        return null;
    }
    get supportsParentFilter() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ((((_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.isRoot) || ((_b = this.parentNode) === null || _b === void 0 ? void 0 : _b.supportsParentFilter)) &&
            ((_d = (_c = this.parentNode) === null || _c === void 0 ? void 0 : _c.databaseConfig) === null || _d === void 0 ? void 0 : _d.conid) == ((_e = this.databaseConfig) === null || _e === void 0 ? void 0 : _e.conid) &&
            ((_g = (_f = this.parentNode) === null || _f === void 0 ? void 0 : _f.databaseConfig) === null || _g === void 0 ? void 0 : _g.database) == ((_h = this.databaseConfig) === null || _h === void 0 ? void 0 : _h.database) &&
            this.engineType == 'sqldb' &&
            ((_j = this.parentNode) === null || _j === void 0 ? void 0 : _j.engineType) == 'sqldb');
    }
    get isParentFilter() {
        var _a;
        return !!((_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.isParentFilter);
    }
    buildParentFilterConditions() {
        var _a;
        const leafNodes = (0, compact_1.default)((((_a = this.config) === null || _a === void 0 ? void 0 : _a.nodes) || [])
            .filter(x => x.isParentFilter)
            .map(x => this.rootNode.findNodeByDesignerId(x.designerId)));
        const conditions = (0, compact_1.default)(leafNodes.map(leafNode => {
            var _a, _b;
            if (leafNode == this)
                return null;
            const select = {
                commandType: 'select',
                from: {
                    name: leafNode.namedObject,
                    alias: 'pert_0',
                    relations: [],
                },
                selectAll: true,
            };
            let lastNode = leafNode;
            let node = leafNode;
            let index = 1;
            let lastAlias = 'pert_0';
            while ((node === null || node === void 0 ? void 0 : node.parentNode) && ((_a = node === null || node === void 0 ? void 0 : node.parentNode) === null || _a === void 0 ? void 0 : _a.designerId) != (this === null || this === void 0 ? void 0 : this.designerId)) {
                node = node.parentNode;
                let alias = `pert_${index}`;
                select.from.relations.push({
                    joinType: 'INNER JOIN',
                    alias,
                    name: node.namedObject,
                    conditions: lastNode.getParentJoinCondition(lastAlias, alias),
                });
                lastAlias = alias;
                lastNode = node;
                index += 1;
            }
            if (((_b = node === null || node === void 0 ? void 0 : node.parentNode) === null || _b === void 0 ? void 0 : _b.designerId) != (this === null || this === void 0 ? void 0 : this.designerId))
                return null;
            select.where = {
                conditionType: 'and',
                conditions: (0, compact_1.default)([
                    ...lastNode.getParentJoinCondition(lastAlias, this.namedObject.pureName),
                    leafNode.getChildrenSqlCondition({ alias: 'pert_0' }),
                ]),
            };
            return {
                conditionType: 'exists',
                subQuery: select,
            };
        }));
        return conditions;
    }
    getParentJoinCondition(alias, parentAlias) {
        return [];
    }
    get sortOrder() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.sort) === null || _b === void 0 ? void 0 : _b.find(x => x.columnName == this.columnName)) === null || _c === void 0 ? void 0 : _c.order;
    }
    get sortOrderIndex() {
        var _a, _b, _c;
        return ((_b = (_a = this.parentNodeConfig) === null || _a === void 0 ? void 0 : _a.sort) === null || _b === void 0 ? void 0 : _b.length) > 1
            ? (0, findIndex_1.default)((_c = this.parentNodeConfig) === null || _c === void 0 ? void 0 : _c.sort, x => x.columnName == this.columnName)
            : -1;
    }
}
exports.PerspectiveTreeNode = PerspectiveTreeNode;
class PerspectiveTableColumnNode extends PerspectiveTreeNode {
    constructor(column, table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId) {
        var _a, _b, _c, _d, _e;
        super(dbs, config, setConfig, parentNode, dataProvider, defaultDatabaseConfig, designerId);
        this.column = column;
        this.table = table;
        this.isTable = !!((_b = (_a = this.db) === null || _a === void 0 ? void 0 : _a.tables) === null || _b === void 0 ? void 0 : _b.find(x => x.schemaName == table.schemaName && x.pureName == table.pureName));
        this.isView = !!((_d = (_c = this.db) === null || _c === void 0 ? void 0 : _c.views) === null || _d === void 0 ? void 0 : _d.find(x => x.schemaName == table.schemaName && x.pureName == table.pureName));
        this.foreignKey = (_e = table === null || table === void 0 ? void 0 : table.foreignKeys) === null || _e === void 0 ? void 0 : _e.find(fk => fk.columns.length == 1 && fk.columns[0].columnName == column.columnName);
        this.refTable = this.db.tables.find(x => { var _a, _b; return x.pureName == ((_a = this.foreignKey) === null || _a === void 0 ? void 0 : _a.refTableName) && x.schemaName == ((_b = this.foreignKey) === null || _b === void 0 ? void 0 : _b.refSchemaName); });
    }
    get engineType() {
        return this.parentNode.engineType;
    }
    matchChildRow(parentRow, childRow) {
        if (!this.foreignKey)
            return false;
        return parentRow[this.foreignKey.columns[0].columnName] == childRow[this.foreignKey.columns[0].refColumnName];
    }
    getChildMatchColumns() {
        if (!this.foreignKey)
            return [];
        return [this.foreignKey.columns[0].columnName];
    }
    getParentMatchColumns() {
        if (!this.foreignKey)
            return [];
        return [this.foreignKey.columns[0].refColumnName];
    }
    getParentJoinCondition(alias, parentAlias) {
        if (!this.foreignKey)
            return [];
        return this.foreignKey.columns.map(column => {
            const res = {
                conditionType: 'binary',
                operator: '=',
                left: {
                    exprType: 'column',
                    columnName: column.columnName,
                    source: { alias: parentAlias },
                },
                right: {
                    exprType: 'column',
                    columnName: column.refColumnName,
                    source: { alias },
                },
            };
            return res;
        });
    }
    createReferenceConfigColumns() {
        var _a, _b;
        return (_b = (_a = this.foreignKey) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.map(col => ({
            source: col.columnName,
            target: col.refColumnName,
        }));
    }
    getNodeLoadProps(parentRows) {
        if (!this.foreignKey)
            return null;
        return {
            schemaName: this.foreignKey.refSchemaName,
            pureName: this.foreignKey.refTableName,
            bindingColumns: [this.foreignKey.columns[0].refColumnName],
            bindingValues: (0, uniqBy_1.default)(parentRows.map(row => [row[this.foreignKey.columns[0].columnName]]), json_stable_stringify_1.default),
            dataColumns: this.getDataLoadColumns(),
            databaseConfig: this.databaseConfig,
            orderBy: this.getOrderBy(this.refTable),
            sqlCondition: this.getChildrenSqlCondition(),
            engineType: 'sqldb',
        };
    }
    get icon() {
        if (this.isCircular)
            return 'img circular';
        if (this.column.autoIncrement)
            return 'img autoincrement';
        if (this.foreignKey)
            return 'img foreign-key';
        return 'img column';
    }
    get codeName() {
        return this.column.columnName;
    }
    get columnName() {
        return this.column.columnName;
    }
    get fieldName() {
        return this.codeName + 'Ref';
        // return this.codeName ;
    }
    get title() {
        return this.column.columnName;
    }
    get isExpandable() {
        return !!this.foreignKey;
    }
    get isSortable() {
        return true;
    }
    get filterBehaviour() {
        return (0, dbgate_tools_1.detectSqlFilterBehaviour)(this.column.dataType);
    }
    get isCircular() {
        var _a, _b;
        return !!((_b = (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.hasTableCode(this.tableCode));
    }
    get isSecondaryChecked() {
        return super.isCheckedColumn;
    }
    get isChecked() {
        if (this.foreignKey)
            return this.isCheckedNode;
        return super.isCheckedColumn;
    }
    get secondaryCheckable() {
        return !!this.foreignKey;
    }
    toggleChecked(value) {
        if (this.foreignKey) {
            this.toggleCheckedNode(value);
        }
        else {
            super.toggleChecked(value);
        }
    }
    toggleSecondaryChecked(value) {
        super.toggleChecked(value == null ? !this.isSecondaryChecked : value);
    }
    generateChildNodes() {
        var _a, _b;
        if (!this.foreignKey)
            return [];
        const tbl = (_b = (_a = this === null || this === void 0 ? void 0 : this.db) === null || _a === void 0 ? void 0 : _a.tables) === null || _b === void 0 ? void 0 : _b.find(x => { var _a, _b; return x.pureName == ((_a = this.foreignKey) === null || _a === void 0 ? void 0 : _a.refTableName) && x.schemaName == ((_b = this.foreignKey) === null || _b === void 0 ? void 0 : _b.refSchemaName); });
        return getTableChildPerspectiveNodes(tbl, this.dbs, this.config, this.setConfig, this.dataProvider, this.defaultDatabaseConfig, this);
    }
    getBaseTableFromThis() {
        return this.refTable;
    }
    get filterInfo() {
        return {
            columnName: this.columnName,
            filterBehaviour: this.filterBehaviour,
            pureName: this.column.pureName,
            schemaName: this.column.schemaName,
            foreignKey: this.foreignKey,
        };
    }
    parseFilterCondition(source = null) {
        const filter = this.getFilter();
        if (!filter)
            return null;
        const condition = (0, dbgate_filterparser_1.parseFilter)(filter, this.filterBehaviour);
        if (!condition)
            return null;
        return (0, cloneDeepWith_1.default)(condition, (expr) => {
            if (expr.exprType == 'placeholder') {
                return {
                    exprType: 'column',
                    columnName: this.column.columnName,
                    source,
                };
            }
        });
    }
    get headerTableAttributes() {
        if (this.foreignKey) {
            return {
                schemaName: this.foreignKey.refSchemaName,
                pureName: this.foreignKey.refTableName,
                conid: this.databaseConfig.conid,
                database: this.databaseConfig.database,
                objectTypeField: this.table.objectTypeField,
            };
        }
        return null;
    }
    get tableCode() {
        if (this.foreignKey) {
            return `${this.foreignKey.refSchemaName}|${this.foreignKey.refTableName}`;
        }
        return `${this.table.schemaName}|${this.table.pureName}`;
    }
    get namedObject() {
        if (this.foreignKey) {
            return {
                schemaName: this.foreignKey.refSchemaName,
                pureName: this.foreignKey.refTableName,
            };
        }
        return null;
    }
}
exports.PerspectiveTableColumnNode = PerspectiveTableColumnNode;
class PerspectivePatternColumnNode extends PerspectiveTreeNode {
    constructor(table, column, tableColumn, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId) {
        var _a;
        super(dbs, config, setConfig, parentNode, dataProvider, defaultDatabaseConfig, designerId);
        this.table = table;
        this.column = column;
        this.tableColumn = tableColumn;
        this.parentNodeConfig = (_a = this.tableNodeOrParent) === null || _a === void 0 ? void 0 : _a.nodeConfig;
        // console.log('PATTERN COLUMN', column);
    }
    get isChildColumn() {
        return this.parentNode instanceof PerspectivePatternColumnNode;
    }
    get findByDesignerIdWithoutDesignerId() {
        return this.isExpandable;
    }
    // matchChildRow(parentRow: any, childRow: any): boolean {
    //   console.log('MATCH PATTENR ROW', parentRow, childRow);
    //   return false;
    //   // if (!this.foreignKey) return false;
    //   // return parentRow[this.foreignKey.columns[0].columnName] == childRow[this.foreignKey.columns[0].refColumnName];
    // }
    // getChildMatchColumns() {
    //   if (!this.foreignKey) return [];
    //   return [this.foreignKey.columns[0].columnName];
    // }
    // getParentMatchColumns() {
    //   if (!this.foreignKey) return [];
    //   return [this.foreignKey.columns[0].refColumnName];
    // }
    // getParentJoinCondition(alias: string, parentAlias: string): Condition[] {
    //   if (!this.foreignKey) return [];
    //   return this.foreignKey.columns.map(column => {
    //     const res: Condition = {
    //       conditionType: 'binary',
    //       operator: '=',
    //       left: {
    //         exprType: 'column',
    //         columnName: column.columnName,
    //         source: { alias: parentAlias },
    //       },
    //       right: {
    //         exprType: 'column',
    //         columnName: column.refColumnName,
    //         source: { alias },
    //       },
    //     };
    //     return res;
    //   });
    // }
    // createReferenceConfigColumns(): PerspectiveReferenceConfig['columns'] {
    //   return this.foreignKey?.columns?.map(col => ({
    //     source: col.columnName,
    //     target: col.refColumnName,
    //   }));
    // }
    getNodeLoadProps(parentRows) {
        // console.log('GETTING PATTERN', parentRows);
        return null;
    }
    get generatesHiearchicGridColumn() {
        var _a, _b, _c;
        // return true;
        // console.log('generatesHiearchicGridColumn', this.parentTableNode?.nodeConfig?.checkedColumns, this.codeName + '::');
        if ((_c = (_b = (_a = this.tableNodeOrParent) === null || _a === void 0 ? void 0 : _a.nodeConfig) === null || _b === void 0 ? void 0 : _b.checkedColumns) === null || _c === void 0 ? void 0 : _c.find(x => x.startsWith(this.codeName + '::'))) {
            return true;
        }
        // return false;
        return this.hasCheckedJoinChild();
    }
    // get generatesHiearchicGridColumn() {
    //   // return this.config &&;
    // }
    get icon() {
        if (this.column.types.includes('json')) {
            return 'img json';
        }
        return 'img column';
    }
    get codeName() {
        if (this.parentNode instanceof PerspectivePatternColumnNode) {
            return `${this.parentNode.codeName}::${this.column.name}`;
        }
        return this.column.name;
    }
    get columnName() {
        return this.column.name;
    }
    get fieldName() {
        return this.column.name;
    }
    get title() {
        return this.column.name;
    }
    get isExpandable() {
        return this.column.columns.length > 0;
    }
    get isSortable() {
        return !this.isChildColumn;
    }
    get filterBehaviour() {
        if (this.tableColumn)
            return (0, dbgate_tools_1.detectSqlFilterBehaviour)(this.tableColumn.dataType);
        return dbgate_tools_1.mongoFilterBehaviour;
    }
    get preloadedLevelData() {
        return true;
    }
    generatePatternChildNodes() {
        return this.column.columns.map(column => new PerspectivePatternColumnNode(this.table, column, this.tableColumn, this.dbs, this.config, this.setConfig, this.dataProvider, this.defaultDatabaseConfig, this, null));
    }
    hasCheckedJoinChild() {
        for (const node of this.childNodes) {
            if (node instanceof PerspectivePatternColumnNode) {
                if (node.hasCheckedJoinChild())
                    return true;
            }
            if (node.isCheckedNode)
                return true;
        }
        return false;
    }
    generateChildNodes() {
        var _a, _b, _c, _d, _e;
        const patternChildren = this.generatePatternChildNodes();
        const customs = [];
        // console.log('GETTING CHILDREN', this.config.nodes, this.config.references);
        for (const node of this.config.nodes) {
            for (const ref of this.config.references) {
                const validDesignerId = this.validParentDesignerId;
                if ((ref.sourceId == validDesignerId && ref.targetId == node.designerId) ||
                    (ref.targetId == validDesignerId && ref.sourceId == node.designerId)) {
                    // console.log('TESTING REF', ref, this.codeName);
                    if (ref.columns.length != 1)
                        continue;
                    // console.log('CP1');
                    if (ref.sourceId == validDesignerId &&
                        this.codeName == (0, perspectiveTools_1.getPerspectiveParentColumnName)(ref.columns[0].source)) {
                        if (ref.columns[0].target.includes('::'))
                            continue;
                    }
                    else if (ref.targetId == validDesignerId &&
                        this.codeName == (0, perspectiveTools_1.getPerspectiveParentColumnName)(ref.columns[0].target)) {
                        if (ref.columns[0].source.includes('::'))
                            continue;
                    }
                    else {
                        continue;
                    }
                    // console.log('CP2');
                    const newConfig = Object.assign({}, this.defaultDatabaseConfig);
                    if (node.conid)
                        newConfig.conid = node.conid;
                    if (node.database)
                        newConfig.database = node.database;
                    const db = (_b = (_a = this.dbs) === null || _a === void 0 ? void 0 : _a[newConfig.conid]) === null || _b === void 0 ? void 0 : _b[newConfig.database];
                    const table = (_c = db === null || db === void 0 ? void 0 : db.tables) === null || _c === void 0 ? void 0 : _c.find(x => x.pureName == node.pureName && x.schemaName == node.schemaName);
                    const view = (_d = db === null || db === void 0 ? void 0 : db.views) === null || _d === void 0 ? void 0 : _d.find(x => x.pureName == node.pureName && x.schemaName == node.schemaName);
                    const collection = (_e = db === null || db === void 0 ? void 0 : db.collections) === null || _e === void 0 ? void 0 : _e.find(x => x.pureName == node.pureName && x.schemaName == node.schemaName);
                    const join = {
                        refNodeDesignerId: node.designerId,
                        referenceDesignerId: ref.designerId,
                        baseDesignerId: validDesignerId,
                        joinName: node.alias,
                        refTableName: node.pureName,
                        refSchemaName: node.schemaName,
                        conid: node.conid,
                        database: node.database,
                        columns: ref.sourceId == validDesignerId
                            ? ref.columns.map(col => ({ baseColumnName: col.source, refColumnName: col.target }))
                            : ref.columns.map(col => ({ baseColumnName: col.target, refColumnName: col.source })),
                    };
                    if (table || view || collection) {
                        customs.push(new PerspectiveCustomJoinTreeNode(join, table || view || collection, this.dbs, this.config, this.setConfig, this.dataProvider, this.defaultDatabaseConfig, this, node.designerId));
                    }
                }
            }
        }
        return [...patternChildren, ...customs];
        // return [];
        // if (!this.foreignKey) return [];
        // const tbl = this?.db?.tables?.find(
        //   x => x.pureName == this.foreignKey?.refTableName && x.schemaName == this.foreignKey?.refSchemaName
        // );
        // return getTableChildPerspectiveNodes(
        //   tbl,
        //   this.dbs,
        //   this.config,
        //   this.setConfig,
        //   this.dataProvider,
        //   this.databaseConfig,
        //   this
        // );
    }
    get filterInfo() {
        if (this.isChildColumn) {
            return null;
        }
        return {
            columnName: this.columnName,
            filterBehaviour: this.filterBehaviour,
            pureName: this.table.pureName,
            schemaName: this.table.schemaName,
            foreignKey: this.foreignKey,
        };
    }
    parseFilterCondition(source = null) {
        const filter = this.getFilter();
        if (!filter)
            return null;
        const condition = (0, dbgate_filterparser_1.parseFilter)(filter, dbgate_tools_1.mongoFilterBehaviour);
        if (!condition)
            return null;
        return (0, cloneDeepWith_1.default)(condition, expr => {
            if (expr.__placeholder__) {
                return {
                    [this.columnName]: expr.__placeholder__,
                };
            }
        });
    }
}
exports.PerspectivePatternColumnNode = PerspectivePatternColumnNode;
class PerspectiveTableNode extends PerspectiveTreeNode {
    constructor(table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId) {
        super(dbs, config, setConfig, parentNode, dataProvider, defaultDatabaseConfig, designerId);
        this.table = table;
        this.dataProvider = dataProvider;
    }
    get engineType() {
        return (0, dbgate_tools_1.isCollectionInfo)(this.table) ? 'docdb' : 'sqldb';
    }
    getNodeLoadProps(parentRows) {
        const isDocDb = (0, dbgate_tools_1.isCollectionInfo)(this.table);
        return {
            schemaName: this.table.schemaName,
            pureName: this.table.pureName,
            dataColumns: this.getDataLoadColumns(),
            allColumns: isDocDb,
            databaseConfig: this.databaseConfig,
            orderBy: this.getOrderBy(this.table),
            sqlCondition: this.getChildrenSqlCondition(),
            engineType: isDocDb ? 'docdb' : 'sqldb',
        };
    }
    get codeName() {
        return this.table.schemaName ? `${this.table.schemaName}:${this.table.pureName}` : this.table.pureName;
    }
    get title() {
        var _a;
        return ((_a = this.nodeConfig) === null || _a === void 0 ? void 0 : _a.alias) || this.table.pureName;
    }
    get isExpandable() {
        return true;
    }
    generateChildNodes() {
        return getTableChildPerspectiveNodes(this.table, this.dbs, this.config, this.setConfig, this.dataProvider, this.defaultDatabaseConfig, this);
    }
    get icon() {
        return 'img table';
    }
    getBaseTableFromThis() {
        return this.table;
    }
    get headerTableAttributes() {
        return {
            schemaName: this.table.schemaName,
            pureName: this.table.pureName,
            conid: this.databaseConfig.conid,
            database: this.databaseConfig.database,
            objectTypeField: this.table.objectTypeField,
        };
    }
    get tableCode() {
        return `${this.table.schemaName}|${this.table.pureName}`;
    }
    get namedObject() {
        return {
            schemaName: this.table.schemaName,
            pureName: this.table.pureName,
        };
    }
}
exports.PerspectiveTableNode = PerspectiveTableNode;
class PerspectiveTableReferenceNode extends PerspectiveTableNode {
    constructor(foreignKey, table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, isMultiple, parentNode, designerId) {
        super(table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId);
        this.foreignKey = foreignKey;
        this.dataProvider = dataProvider;
        this.isMultiple = isMultiple;
    }
    matchChildRow(parentRow, childRow) {
        if (!this.foreignKey)
            return false;
        return parentRow[this.foreignKey.columns[0].refColumnName] == childRow[this.foreignKey.columns[0].columnName];
    }
    getChildMatchColumns() {
        if (!this.foreignKey)
            return [];
        return [this.foreignKey.columns[0].refColumnName];
    }
    getParentMatchColumns() {
        if (!this.foreignKey)
            return [];
        return [this.foreignKey.columns[0].columnName];
    }
    getNodeLoadProps(parentRows) {
        if (!this.foreignKey)
            return null;
        return {
            schemaName: this.table.schemaName,
            pureName: this.table.pureName,
            bindingColumns: [this.foreignKey.columns[0].columnName],
            bindingValues: (0, uniqBy_1.default)(parentRows.map(row => [row[this.foreignKey.columns[0].refColumnName]]), json_stable_stringify_1.default),
            dataColumns: this.getDataLoadColumns(),
            databaseConfig: this.databaseConfig,
            orderBy: this.getOrderBy(this.table),
            sqlCondition: this.getChildrenSqlCondition(),
            engineType: 'sqldb',
        };
    }
    createReferenceConfigColumns() {
        var _a, _b;
        return (_b = (_a = this.foreignKey) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.map(col => ({
            source: col.refColumnName,
            target: col.columnName,
        }));
    }
    get columnTitle() {
        return this.table.pureName;
    }
    get title() {
        if (this.isMultiple) {
            return `${super.title} (${this.foreignKey.columns.map(x => x.columnName).join(', ')})`;
        }
        return super.title;
    }
    get codeName() {
        if (this.isMultiple) {
            return `${super.codeName}-${this.foreignKey.columns.map(x => x.columnName).join('_')}`;
        }
        return super.codeName;
    }
    get isChecked() {
        return this.isCheckedNode;
    }
    toggleChecked(value) {
        this.toggleCheckedNode(value);
    }
    getParentJoinCondition(alias, parentAlias) {
        if (!this.foreignKey)
            return [];
        return this.foreignKey.columns.map(column => {
            const res = {
                conditionType: 'binary',
                operator: '=',
                left: {
                    exprType: 'column',
                    columnName: column.refColumnName,
                    source: { alias: parentAlias },
                },
                right: {
                    exprType: 'column',
                    columnName: column.columnName,
                    source: { alias },
                },
            };
            return res;
        });
    }
}
exports.PerspectiveTableReferenceNode = PerspectiveTableReferenceNode;
class PerspectiveCustomJoinTreeNode extends PerspectiveTableNode {
    constructor(customJoin, table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId) {
        super(table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId);
        this.customJoin = customJoin;
        this.dataProvider = dataProvider;
    }
    matchChildRow(parentRow, childRow) {
        // console.log('MATCH ROW', parentRow, childRow);
        for (const column of this.customJoin.columns) {
            if (!(0, perspectiveTools_1.perspectiveValueMatcher)(parentRow[(0, perspectiveTools_1.getPerspectiveMostNestedChildColumnName)(column.baseColumnName)], childRow[column.refColumnName])) {
                return false;
            }
        }
        return true;
    }
    getChildMatchColumns() {
        return this.customJoin.columns.map(x => x.baseColumnName);
    }
    getParentMatchColumns() {
        return this.customJoin.columns.map(x => x.refColumnName);
    }
    getNodeLoadProps(parentRows) {
        // console.log('CUSTOM JOIN', this.customJoin);
        // console.log('PARENT ROWS', parentRows);
        // console.log('this.getDataLoadColumns()', this.getDataLoadColumns());
        const isDocDb = (0, dbgate_tools_1.isCollectionInfo)(this.table);
        // const bindingValues = [];
        // for (const row of parentRows) {
        //   const rowBindingValueArrays = [];
        //   for (const col of this.customJoin.columns) {
        //     const path = col.baseColumnName.split('::');
        //     const values = [];
        //     function processSubpath(parent, subpath) {
        //       if (subpath.length == 0) {
        //         values.push(parent);
        //         return;
        //       }
        //       if (parent == null) {
        //         return;
        //       }
        //       const obj = parent[subpath[0]];
        //       if (_isArray(obj)) {
        //         for (const elem of obj) {
        //           processSubpath(elem, subpath.slice(1));
        //         }
        //       } else {
        //         processSubpath(obj, subpath.slice(1));
        //       }
        //     }
        //     processSubpath(row, path);
        //     rowBindingValueArrays.push(values);
        //   }
        //   const valueCount = Math.max(...rowBindingValueArrays.map(x => x.length));
        //   for (let i = 0; i < valueCount; i += 1) {
        //     const value = Array(this.customJoin.columns.length);
        //     for (let col = 0; col < this.customJoin.columns.length; col++) {
        //       value[col] = rowBindingValueArrays[col][i % rowBindingValueArrays[col].length];
        //     }
        //     bindingValues.push(value);
        //   }
        // }
        const bindingValues = parentRows.map(row => this.customJoin.columns.map(x => row[(0, perspectiveTools_1.getPerspectiveMostNestedChildColumnName)(x.baseColumnName)]));
        // console.log('bindingValues', bindingValues);
        // console.log(
        //   'bindingValues UNIQ',
        //   _uniqBy(bindingValues, x => JSON.stringify(x))
        // );
        return {
            schemaName: this.table.schemaName,
            pureName: this.table.pureName,
            bindingColumns: this.getParentMatchColumns(),
            bindingValues: (0, uniqBy_1.default)(bindingValues, x => JSON.stringify(x)),
            dataColumns: this.getDataLoadColumns(),
            allColumns: isDocDb,
            databaseConfig: this.databaseConfig,
            orderBy: this.getOrderBy(this.table),
            sqlCondition: this.getChildrenSqlCondition(),
            // mongoCondition: isMongo ? this.getChildrenMongoCondition() : null,
            engineType: isDocDb ? 'docdb' : 'sqldb',
        };
    }
    // get title() {
    //   return this.customJoin.joinName || this.customJoin.refTableName;
    // }
    get icon() {
        return 'icon custom-join';
    }
    get codeName() {
        return this.customJoin.refNodeDesignerId;
    }
    get customJoinConfig() {
        return this.customJoin;
    }
    get isChecked() {
        return this.isCheckedNode;
    }
    toggleChecked(value) {
        this.toggleCheckedNode(value);
    }
    getParentJoinCondition(alias, parentAlias) {
        return this.customJoin.columns.map(column => {
            const res = {
                conditionType: 'binary',
                operator: '=',
                left: {
                    exprType: 'column',
                    columnName: column.baseColumnName,
                    source: { alias: parentAlias },
                },
                right: {
                    exprType: 'column',
                    columnName: column.refColumnName,
                    source: { alias },
                },
            };
            return res;
        });
    }
}
exports.PerspectiveCustomJoinTreeNode = PerspectiveCustomJoinTreeNode;
function findDesignerIdForNode(config, parentNode, nodeCreateFunc) {
    const node = nodeCreateFunc(null);
    const refColumns = node.createReferenceConfigColumns();
    if (!(refColumns === null || refColumns === void 0 ? void 0 : refColumns.length)) {
        return node;
    }
    const ref1 = config.references.find(x => x.sourceId == parentNode.designerId &&
        (0, isEqual_1.default)(refColumns.map(x => x.source), x.columns.map(x => x.source)) &&
        (0, isEqual_1.default)(refColumns.map(x => x.target), x.columns.map(x => x.target)) &&
        (0, dbgate_tools_1.equalFullName)(config.nodes.find(n => n.designerId == x.targetId), node.namedObject));
    if (ref1 && !parentNode.hasDesignerIdInIncestors(ref1.targetId)) {
        // console.log('FOUND1', node.title, ref1.targetId, refColumns);
        return nodeCreateFunc(ref1.targetId);
    }
    const ref2 = config.references.find(x => x.targetId == parentNode.designerId &&
        (0, isEqual_1.default)(refColumns.map(x => x.target), x.columns.map(x => x.source)) &&
        (0, isEqual_1.default)(refColumns.map(x => x.source), x.columns.map(x => x.target)) &&
        (0, dbgate_tools_1.equalFullName)(config.nodes.find(n => n.designerId == x.sourceId), node.namedObject));
    if (ref2 && !parentNode.hasDesignerIdInIncestors(ref2.sourceId)) {
        // console.log('FOUND2', node.title, ref2.sourceId, refColumns);
        return nodeCreateFunc(ref2.sourceId);
    }
    return node;
}
function getTableChildPerspectiveNodes(table, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!table)
        return [];
    const db = parentNode.db;
    const pattern = (_a = dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.dataPatterns) === null || _a === void 0 ? void 0 : _a[parentNode.designerId];
    const tableOrView = (0, dbgate_tools_1.isTableInfo)(table) || (0, dbgate_tools_1.isViewInfo)(table) ? table : null;
    const columnNodes = ((_b = tableOrView === null || tableOrView === void 0 ? void 0 : tableOrView.columns) === null || _b === void 0 ? void 0 : _b.map(col => findDesignerIdForNode(config, parentNode, designerId => {
        var _a, _b, _c;
        return ((_b = (_a = pattern === null || pattern === void 0 ? void 0 : pattern.columns) === null || _a === void 0 ? void 0 : _a.find(x => x.name == col.columnName)) === null || _b === void 0 ? void 0 : _b.types.includes('json'))
            ? new PerspectivePatternColumnNode(table, (_c = pattern === null || pattern === void 0 ? void 0 : pattern.columns) === null || _c === void 0 ? void 0 : _c.find(x => x.name == col.columnName), col, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId)
            : new PerspectiveTableColumnNode(col, tableOrView, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId);
    }))) ||
        ((_c = pattern === null || pattern === void 0 ? void 0 : pattern.columns) === null || _c === void 0 ? void 0 : _c.map(col => findDesignerIdForNode(config, parentNode, designerId => new PerspectivePatternColumnNode(table, col, null, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, designerId)))) ||
        [];
    // if (!columnNodes.find(x => x.isChecked)) {
    //   const circularColumns = columnNodes.filter(x => x.isCircular).map(x => x.columnName);
    //   const defaultColumns = getPerspectiveDefaultColumns(table, db, circularColumns);
    //   for (const node of columnNodes) {
    //     if (defaultColumns.includes(node.columnName)) {
    //       no
    //     }
    //   }
    // }
    const res = [];
    res.push(...columnNodes);
    const dependencies = [];
    if (db && (table === null || table === void 0 ? void 0 : table.dependencies)) {
        for (const fk of table === null || table === void 0 ? void 0 : table.dependencies) {
            const tbl = db.tables.find(x => x.pureName == fk.pureName && x.schemaName == fk.schemaName);
            if (tbl) {
                const isMultiple = (table === null || table === void 0 ? void 0 : table.dependencies.filter(x => x.pureName == fk.pureName && x.schemaName == fk.schemaName).length) >= 2;
                dependencies.push(findDesignerIdForNode(config, parentNode, designerId => new PerspectiveTableReferenceNode(fk, tbl, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, isMultiple, parentNode, designerId)));
            }
        }
    }
    res.push(...(0, sortBy_1.default)(dependencies, 'title'));
    const customs = [];
    for (const node of config.nodes) {
        if (node.designerId == ((_d = parentNode.parentNode) === null || _d === void 0 ? void 0 : _d.designerId) || res.find(x => x.designerId == node.designerId)) {
            // already used as FK
            continue;
        }
        for (const ref of config.references) {
            if ((ref.sourceId == parentNode.designerId && ref.targetId == node.designerId) ||
                (ref.targetId == parentNode.designerId && ref.sourceId == node.designerId)) {
                if (ref.columns.find(x => x.source.includes('::') || x.target.includes('::'))) {
                    continue;
                }
                const newConfig = Object.assign({}, defaultDatabaseConfig);
                if (node.conid)
                    newConfig.conid = node.conid;
                if (node.database)
                    newConfig.database = node.database;
                const db = (_e = dbs === null || dbs === void 0 ? void 0 : dbs[newConfig.conid]) === null || _e === void 0 ? void 0 : _e[newConfig.database];
                const table = (_f = db === null || db === void 0 ? void 0 : db.tables) === null || _f === void 0 ? void 0 : _f.find(x => x.pureName == node.pureName && x.schemaName == node.schemaName);
                const view = (_g = db === null || db === void 0 ? void 0 : db.views) === null || _g === void 0 ? void 0 : _g.find(x => x.pureName == node.pureName && x.schemaName == node.schemaName);
                const collection = (_h = db === null || db === void 0 ? void 0 : db.collections) === null || _h === void 0 ? void 0 : _h.find(x => x.pureName == node.pureName && x.schemaName == node.schemaName);
                const join = {
                    refNodeDesignerId: node.designerId,
                    referenceDesignerId: ref.designerId,
                    baseDesignerId: parentNode.designerId,
                    joinName: node.alias,
                    refTableName: node.pureName,
                    refSchemaName: node.schemaName,
                    conid: node.conid,
                    database: node.database,
                    columns: ref.sourceId == parentNode.designerId
                        ? ref.columns.map(col => ({ baseColumnName: col.source, refColumnName: col.target }))
                        : ref.columns.map(col => ({ baseColumnName: col.target, refColumnName: col.source })),
                };
                if (table || view || collection) {
                    customs.push(new PerspectiveCustomJoinTreeNode(join, table || view || collection, dbs, config, setConfig, dataProvider, defaultDatabaseConfig, parentNode, node.designerId));
                }
            }
        }
    }
    res.push(...(0, sortBy_1.default)(customs, 'title'));
    return res;
}
exports.getTableChildPerspectiveNodes = getTableChildPerspectiveNodes;
